function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["animation", "aria-labelledby", "children", "className", "height", "id", "size", "style", "type", "width"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React from 'react';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
/**
 * Base dialog type displays dialog as either modal or drawer, and which is the heart of the dialog component
 * @param props DialogTypeProps
 */
var DialogType = function DialogType(props) {
  var _classnames;
  var animation = props.animation,
    ariaLabelledBy = props['aria-labelledby'],
    children = props.children,
    className = props.className,
    height = props.height,
    id = props.id,
    size = props.size,
    style = props.style,
    type = props.type,
    width = props.width,
    otherProps = _objectWithoutProperties(props, _excluded);
  // position is used for drawer dialogs
  // fade-in-from-left => left
  // fade-in-from-right => right
  var position = animation.split('-').pop();
  return /*#__PURE__*/React.createElement("div", _extends({}, otherProps, {
    "aria-labelledby": ariaLabelledBy,
    "aria-modal": true,
    className: classnames((_classnames = {
      'bf-dialog__type': true
    }, _defineProperty(_classnames, "bf-dialog__type--".concat(type), type), _defineProperty(_classnames, "bf-dialog__type--animation-".concat(animation), animation), _defineProperty(_classnames, "bf-dialog__type--position-".concat(position), position), _defineProperty(_classnames, "bf-dialog__type--size-".concat(size), size), _defineProperty(_classnames, "".concat(className), !!className), _classnames)),
    id: id,
    role: "dialog",
    style: _objectSpread(_objectSpread({}, style), {}, {
      height: height !== undefined && height > 0 ? height : undefined,
      width: width !== undefined && width > 0 ? width : undefined
    })
  }), children);
};
export { DialogType };